__turbopack_context__.v({
  "entityList": "ReplaceEntityModal-module__dNFbVW__entityList",
  "image": "ReplaceEntityModal-module__dNFbVW__image",
  "label": "ReplaceEntityModal-module__dNFbVW__label",
  "preview": "ReplaceEntityModal-module__dNFbVW__preview",
  "selected": "ReplaceEntityModal-module__dNFbVW__selected",
});
